import axios from 'axios';
import { authHeader } from '../_helpers/auth-header';

const BASE_URL = '/api/users';

export const userApi = {
  // 사용자 목록 조회
  getUsers(params) {
    return axios.get(BASE_URL, {
      params,
      headers: { Authorization: authHeader() }
    });
  },

  // 사용자 생성
  createUser(userData) {
    return axios.post(BASE_URL, userData, {
      headers: { Authorization: authHeader() }
    });
  },

  // 사용자 수정
  updateUser(userId, userData) {
    return axios.put(`${BASE_URL}/${userId}`, userData, {
      headers: { Authorization: authHeader() }
    });
  },

  // 사용자 삭제
  deleteUser(userId) {
    return axios.delete(`${BASE_URL}/${userId}`, {
      headers: { Authorization: authHeader() }
    });
  },

  // 비밀번호 변경
  changePassword(userId, passwordData) {
    return axios.patch(`${BASE_URL}/${userId}/password`, passwordData, {
      headers: { Authorization: authHeader() }
    });
  }
};
